import React, { useEffect, useState } from "react";
import { Cart } from "@dining/api-client";
import { Body1, Body1Strong, Subtitle1 } from "@fluentui/react-components";
import { useStyles } from "./useStyles";
import { HelperUtils } from "../../../common";

type CartHeaderProps = {
  cart?: Cart;
};

export const CartHeader = ({ cart }: CartHeaderProps) => {
  const styles = useStyles();
  const [isCartEmpty, setIsCartEmpty] = useState<boolean>(true);
  useEffect(() => {
    if (!cart || cart.items.length === 0) {
      setIsCartEmpty(true);
    } else {
      setIsCartEmpty(false);
    }
  }, [cart]);

  const stationNamesStr = cart
    ? HelperUtils.getInstance().getUniqueFormattedStationNames(cart)
    : "";

  return (
    <div className={styles.container} data-testid="CartHeader">
      <Subtitle1 className={styles.title}>Your Order</Subtitle1>
      {!isCartEmpty && (
        <div className={styles.info}>
          <Body1Strong className={styles.infoTitle}>Order location</Body1Strong>
          <Body1 className={styles.infoSubtitle}>
            {cart?.cafeName}: {stationNamesStr}
          </Body1>
        </div>
      )}
    </div>
  );
};
